import { createContext, useContext } from "react";

/**
 * Provider-value is the result of useProductFormOptions(). Having a dedicated
 * context (instead of prop drilling) keeps every option fetch centralized in
 * the shell — each consumer just reads what it needs.
 */
export const FormOptionsContext = createContext(null);

export const useFormOptions = () => {
  const ctx = useContext(FormOptionsContext);
  if (!ctx) {
    throw new Error(
      "useFormOptions must be used inside <FormOptionsContext.Provider>.",
    );
  }
  return ctx;
};
